import { CommonModule } from "@angular/common";
import { Component, ChangeDetectionStrategy, Input, ViewChild } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { ItButtonDirective, ItCheckboxComponent, ItModalComponent, ItNotificationsComponent, ItNotificationService, NotificationPosition } from "design-angular-kit";
import { LoaderService } from "../../service/loader.service";
import { UtentiMasterService } from "./utenti-master.service";
import { Subscription } from "rxjs";
import { AppService } from "../../service/app.service";
import { AnagraficaEnte } from "../../interfaces/anagrafica-ente.interface";
import { StatiUtenteMaster } from "../../shared/enum/stati-utente-master.enum";
import { Utente } from "../../interfaces/user";

@Component({
  selector: 'app-badge',
  standalone: true,
  templateUrl: './badge.component.html',
  imports: [
    CommonModule, ItCheckboxComponent, FormsModule, ItModalComponent, ItButtonDirective, ItNotificationsComponent
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BadgeComponent {
  @Input() element: any;
  constructor(
    private loader: LoaderService,
    private appService: AppService,
    private utentiMasterService: UtentiMasterService,
    private notificationService: ItNotificationService,
  ) {}
  pageSubscription = new Subscription();
  @ViewChild('confirmModal') confirmModal!: ItModalComponent;
  ente: AnagraficaEnte = {};
  user: Utente = {};
  statiUtenteMaster = StatiUtenteMaster;

  ngOnInit(): void {
    this.ente = this.appService.ente;
    this.user = this.appService.user;
  }

  openConfirmModal(event: any): void {
    event.preventDefault();
    if (this.element.flagPrincipale || this.isNotAttivabile(this.element) || this.element.codiceFiscale === this.user.idUtente) {
      return;
    }
    this.confirmModal.show();
  }

  submit(): void {
    if (!this.element.isAttivo) {
      this.loader.show();
      this.pageSubscription.add(
        this.utentiMasterService.attiva(this.element.idUtenteMaster, this.element).subscribe({
          next: (el: any) => {
            if (el) {
              this.confirmModal.hide();
              this.notificationService.success(
                `Utente attivato con successo!`, '', false, 3000, NotificationPosition.Bottom
              );
              this.element.isAttivo = true;
            }
          },
          error: () => {
            this.confirmModal.hide();
            this.loader.hide();
          },
          complete: () => this.loader.hide(),
        })
      );
    } else {
      this.loader.show();
      this.pageSubscription.add(
        this.utentiMasterService.disattiva(this.element.idUtenteMaster, this.element).subscribe({
          next: (el: any) => {
            if (el) {
              this.confirmModal.hide();
              this.notificationService.success(
                `Utente disattivato con successo!`, '', false, 3000, NotificationPosition.Bottom
              );
              this.element.isAttivo = false;
            }
          },
          error: () => {
            this.confirmModal.hide();
            this.loader.hide();
          },
          complete: () => this.loader.hide(),
        })
      );
    }
  }

  isNotAttivabile(element: any): boolean {
    const statiNonValidi = [
      StatiUtenteMaster.InBozza,
      StatiUtenteMaster.InvioMailInCorso,
      StatiUtenteMaster.EmailNonConfermata,
      StatiUtenteMaster.InAttesaConfermaEmail,
      StatiUtenteMaster.ErroreInvioEmail
    ];
    if (statiNonValidi.includes(element.statoUtenteMaster.idStatoUtenteMaster)) {
      return true;
    }
    return false;
  }

  closeModal(): void {
    this.confirmModal.hide();
  }

  ngOnDestroy(): void {
    this.pageSubscription.unsubscribe();
  }
}
